import React from 'react';
import { C } from './dashboardConstants';

export const WeeklyWinsCard = ({ streak, meals, navigate, showSubtitle = true }) => {
  return (
    <div className="nuri-reveal nuri-d3" data-testid="wins-banner" onClick={() => navigate('/weekly-summary')} style={{
      borderRadius: 20, marginBottom: 16,
      position: 'relative', overflow: 'hidden', cursor: 'pointer',
    }}>
      <img src="/food-images/smoothie_bowl.png" alt="" aria-hidden="true" style={{
        position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover',
        filter: 'saturate(1.1) brightness(1.05) sepia(0.05)',
      }} />
      <div style={{ position: 'absolute', inset: 0, background: 'rgba(245, 220, 200, 0.85)' }} />
      <div style={{ position: 'relative', zIndex: 1, padding: '28px 22px' }}>
        <p style={{ fontFamily: 'var(--font-serif)', fontSize: 22, margin: '0 0 4px', color: C.text, fontWeight: 400, textAlign: 'left' }}>
          Your Progress This Week
        </p>
        <p style={{ fontSize: 12, color: C.textSec, margin: '0 0 12px', fontFamily: 'var(--font-sans)' }}>
          {showSubtitle
            ? (streak?.streak > 0 ? `You've been consistent for ${streak.streak} days` : 'A look at what you accomplished in the last 7 days')
            : ''}
        </p>
        <div style={{ display: 'flex', gap: 20 }}>
          <div>
            <p style={{ fontSize: 28, margin: 0, fontWeight: 500, color: C.text, fontFamily: 'var(--font-sans)' }}>{streak?.streak || 0}</p>
            <p style={{ fontSize: 11, margin: 0, color: C.textSec, fontFamily: 'var(--font-sans)' }}>day streak</p>
          </div>
          <div>
            <p style={{ fontSize: 28, margin: 0, fontWeight: 500, color: C.text, fontFamily: 'var(--font-sans)' }}>{meals.length}</p>
            <p style={{ fontSize: 11, margin: 0, color: C.textSec, fontFamily: 'var(--font-sans)' }}>meals today</p>
          </div>
          <div>
            <p style={{ fontSize: 28, margin: 0, fontWeight: 500, color: C.green, fontFamily: 'var(--font-sans)' }}>
              {meals.length > 0 ? (meals.filter(m => ['A+','A','A-','B+','B'].includes(m.final_analysis?.health_score)).length > meals.length / 2 ? 'B+' : 'C+') : '--'}
            </p>
            <p style={{ fontSize: 11, margin: 0, color: C.textSec, fontFamily: 'var(--font-sans)' }}>avg score</p>
          </div>
        </div>
      </div>
    </div>
  );
};
